const purchaseDisabledSubBrands = ['bluehost_in'];

export const getPurchaseDisabledSubBrand = (subBrand: string = '') =>
  purchaseDisabledSubBrands.includes(subBrand);
